import {routes} from "../constants/constants"

export default (path) => {
    return Object.keys(routes).find(k => routes[k] === path)
}